export const unidadesFederativas = [
  { sigla: "AC", nome: "AC" },
  { sigla: "AL", nome: "AL" },
  { sigla: "AP", nome: "AP" },
  { sigla: "AM", nome: "AM" },
  { sigla: "BA", nome: "BA" },
  { sigla: "CE", nome: "CE" },
  { sigla: "DF", nome: "DF" },
  { sigla: "ES", nome: "ES" },
  { sigla: "GO", nome: "GO" },
  { sigla: "MA", nome: "MA" },
  { sigla: "MT", nome: "MT" },
  { sigla: "MS", nome: "MS" },
  { sigla: "MG", nome: "MG" },
  { sigla: "PA", nome: "PA" },
  { sigla: "PB", nome: "PB" },
  { sigla: "PR", nome: "PR" },
  { sigla: "PE", nome: "PE" },
  { sigla: "PI", nome: "PI" },
  { sigla: "RJ", nome: "RJ" },
  { sigla: "RN", nome: "RN" },
  { sigla: "RS", nome: "RS" },
  { sigla: "RO", nome: "RO" },
  { sigla: "RR", nome: "RR" },
  { sigla: "SC", nome: "SC" },
  { sigla: "SP", nome: "SP" },
  { sigla: "SE", nome: "SE" },
  { sigla: "TO", nome: "TO" },
];
